import StarEmptyIcon from '../star-empty';
import StarFullIcon from '../star-full';
import StarHalfIcon from '../star-half';

const starIconsSources = {
  FULL: StarFullIcon,
  HALF: StarHalfIcon,
  EMPTY: StarEmptyIcon,
};

export default starIconsSources;
